<template>
  <DataTableAsync
    :data="tableData"
    :length="(filteredData || []).length"
    v-model="tableState"
    :tableWrapClass="tableWrapClass"
    :tableClass="tableClass"
    :noSearch="propToBool(noSearch)"
    :noFooter="propToBool(noFooter)"
    :searchPlaceholder="searchPlaceholder"
    :isLoading="isLoading"
    :scrollable="propToBool(scrollable)"
    ref="dataTable"
  >
    <template #menu>
      <div class="hvh-flex">
        <slot name="menu" />
      </div>
    </template>
    <template #head>
      <slot name="head" />
    </template>
    <template #body="{ item, index }">
      <slot name="body" :item="item" :index="index" />
    </template>
  </DataTableAsync>
</template>

<script>
import { Debouncer, isString, propToBool, propToFnc, sanitize } from '../../../libraries/common';
import DataTableAsync from './DataTableAsync.vue';
import { saveAs } from 'file-saver';

export default {
  components: { DataTableAsync, },
  props: ['data', 'value', 'tableWrapClass', 'tableClass', 'noSearch', 'noFooter', 'searchPlaceholder', 'isLoading', 'scrollable', 'perPage', 'exportTitle'],
  data(self) {
    return {
      localValue: { ...self.value },
      searchDebounce: new Debouncer(500),
      colspanLength: 0,
      $tds: [],
      tableState: { page: 1, perPage: this.perPage || 5 },
    };
  },
  computed: {
    filteredData() {
      if (propToBool(this.noSearch) || !this.tableState.searchText)
        return this.data;

      var search = this.tableState.searchText.toLowerCase();
      return this.data
        .filter(f => this.headerFncs.any(fnc => (fnc(f) || '').toString().toLowerCase().includes(search)));
    },
    sortedData() {
      var response = (this.filteredData || []);

      if (this.tableState.sortByProp) {
        response = response.sortBy(this.tableState.sortByProp);
        if (this.tableState.sortDirection === 'desc')
          response = response.reverse();
      }
      return response;
    },
    tableData() {
      return this.sortedData
        .skip(this.tableState.perPage * (this.tableState.page - 1))
        .take(this.tableState.perPage);
    },
    isDataTable() {
      return true;
    },
  },
  methods: {
    emitState(obj) {
      if (!this.$listeners['input'])
        this.localValue = { ...this.localValue, ...obj };
      else
        this.$emit('input', { ...this.localValue, ...obj });
    },
    debounceSearch(searchText) {
      this.searchDebounce.clear().push(() => this.emitState({ page: 1, searchText }));
    },
    calculateColspanLength() {
      if (this.$refs.head) {
        return this.colspanLength = Array.from(this.$refs.head.childNodes)
          .max(f => f.childNodes.length);
      }
      return 0;
    },
    exportToCSV() {
      var headers = this.$refs.dataTable.getHeadChildren().filter(f => f.exportFnc);
      var fncs = headers.map(f => f.exportFnc);
      var result = [
        headers.map(f => f.$el.innerText).join(','),
        ...this.sortedData
          .map(f => fncs.map(fnc => {
            var val = fnc(f);
            return isString(val) && val.indexOf(',') > -1 ? `"${val}"` : val;
          }).join(','))
      ];
      var blob = new Blob([result.join('\n')], { type: "text/plain;charset=utf-8" });
      saveAs(blob, sanitize(`${this.exportTitle || 'exported'} ${this.browserDateTime(new Date()).replaceAll('/', '-').replaceAll(':', '-')}.csv`));
    },
    getHeaderFncs() {
      var headers = this.$refs.dataTable.getHeadChildren();
      this.headerFncs = headers
        .filter(f => f.prop)
        .map(f => propToFnc(f.prop));
    },
    propToBool,
  },
  watch: {
    value() {
      this.localValue = { ...this.value };
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window.thisDataTable = this;

    this.getHeaderFncs();
    setTimeout(this.getHeaderFncs, 1000);
  },
};
</script>
